module.exports = __webpack_public_path__ + "img/q3-roll-02.f422f77f.svg";